import React from 'react';

export default function SectionComplete({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="10.309"
      height="9.422"
      viewBox="0 0 10.309 9.422"
    >
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1.991 3.657l3.05 4.237 3.765-5.583"
        data-name="Path 3935"
      ></path>
    </svg>
  );
}
